import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  compareDate,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import { toast } from "react-toastify";
import PledgeMasterTable from "../../../Components/ReportTables/PledgeMasterTable";

function PledgeMasterReportNew(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [onDate, setOnDate] = useState("");
  const [gridData, setGridData] = useState([]);
  const [mainLoader, setMainLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const [dateErrorResp, setDateErrorResp] = useState(false);
  const ClientId2 = localStorage.getItem("ClientId2");


  // useEffect(() => {
  if (onDate == "") {
    const current = new Date();
    const date = `${
      current.getMonth() + 1
    }-${current.getDate()}-${current.getFullYear()}`;
    const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    setOnDate(date1);
  }

  // }, []);

  let clientCode = "";
  const getPledgeMaster = async (fileType = "grid", clientCode) => {
    if (fileType === "grid") {
      setMainLoader(true);
    }
    if (fileType === "excel") {
      setSmallLoaderExcel(true);
    }
    if (fileType === "pdf") {
      setSmallLoaderPdf(true);
    }
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      date: onDate,
      fileType: fileType,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.PledgeMasterReport_URL,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setErrorGrid(false);
        if (fileType === "grid") {
          setGridData(res?.data?.pldList);
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setGridData([]);
        if (fileType !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);

      if (fileType !== "grid") {
        toast.error(error?.message);
      } else {
        setErrorGrid(error?.message);
      }
    } finally {
      setMainLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
  };

  const handleOnDateChange = (e) => {
    setGridData([]);
    setErrorGrid(false);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setOnDate(d);
    setDateErrorResp(false);
  };

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (compareDate(onDate)) {
        getPledgeMaster("grid", clientCode);
      } else {
        setDateErrorResp("Please Select Correct Date.");
      }
    }

    // setFileType("");
  }, []);

  const handleOnClick = (e) => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (e.target.value) {
        if (compareDate(onDate)) {
          setErrorGrid(false);
          getPledgeMaster(e.target.value, clientCode);
        } else {
          setDateErrorResp("Please Select Correct Date.");
        }
      }
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="client-holding"
        role="tabpanel"
        aria-labelledby="client-holding"
      >
        <div className="reports-date-filter">
          <div className="reports-left-form">
            <form>
              <div className="report-form-wrapper">
                <div className="form-group">
                  <label className="form-label" htmlFor="to">
                    {Constants.As_On_Date}
                  </label>
                  <input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    // className="datepicker"
                    max={DateReverse}
                    defaultValue={formatDate(onDate)}
                    className="OnDate"
                    onChange={handleOnDateChange}
                  />
                  <span className="date-error">{dateErrorResp}</span>
                </div>
              </div>
            </form>
            <button
              className="generate-button get-data"
              value="grid"
              onClick={handleOnClick}
            >
              {/* <span class="icon-block-menu"></span> */}

              {Constants.Submit}
            </button>
          </div>
          <div className="report-btn-wrapper">
            <button
              value="excel"
              onClick={handleOnClick}
              className="generate-button excel-btn"
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {mainLoader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : (
        gridData.length > 0 && <PledgeMasterTable gridData={gridData} />
      )}

      {errorGrid && (
        <h4 className="report-error-message">{noDataFound(errorGrid)}</h4>
      )}
    </>
  );
}
export default PledgeMasterReportNew;
